import { render, staticRenderFns } from "./eventpicker.vue?vue&type=template&id=af95f96c&scoped=true&"
import script from "./eventpicker.vue?vue&type=script&lang=js&"
export * from "./eventpicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af95f96c",
  null
  
)

export default component.exports